export enum MINI_CONTROLLER_TEST_IDS {
    ACTION_BUTTON = 'action_button',
    CONTAINER = 'container',
}
